import { StyleRules } from '@mui/styles'

const stylesheet: StyleRules = {
  root: {
    minWidth: 100,
  },
  activeBtn: {
    color: '#FFF !important',
    backgroundColor: 'var(--color-primary) !important',
    padding: '0px 5px !important',
    width: '5rem !important',
    borderRadius: '1rem !important'
  },
  actionIcon: {
    opacity: '80% !important',
    fontSize: '1.1rem !important',
    padding: '0px !important',
  },
  tablePaddingPListHeader: {
    padding: '0.4rem !important',
    // border: 'none !important',
    backgroundColor: 'var(--color-paper) !important',
  },
  tablePaddingPList: {
    padding: '0.4rem !important',
    border: 'none !important',
  },
};

export default stylesheet;